import React, { memo } from 'react'
import { useNewsCard, NewsCardProps } from './useNewsCard'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './NewsCard.module.scss'

const NewsCard: React.FC<NewsCardProps> = (props: NewsCardProps) => {
  const {
    title,
    description,
    author,
    category,
    image,
    authorImage,
    url,
    date,
    isAr,
    tagsIds,
    t,
  } = useNewsCard(props)

  return (
    <Link
      to={url}
      style={{ textDecoration: 'none' }}
      data-tags-ids={tagsIds ? tagsIds : ''}
    >
      <div className={`${styles['news-card']} position-relative h-100`}>
        <div
          className={`${styles['news-img']} position-relative overflow-hidden`}
        >
          <img src={image} alt='news' height={260} width='100%' />
          <span className={`${styles['news-date']}`}>{date}</span>
        </div>
        <div className={styles.meta}>
          <div className='d-flex align-items-center'>
            {authorImage ? (
              <img
                src={authorImage}
                width={35}
                height={35}
                className='rounded-circle flex-shrink-0'
                alt='author image'
              />
            ) : (
              <FontAwesomeIcon icon='pen-nib' color='#d2b234' />
            )}
            <span style={{ marginInlineStart: '6px' }}>{author}</span>
          </div>
          <span className={`${styles.splitter} px-3`}>/</span>
          <div className='d-flex align-items-center'>
            <FontAwesomeIcon icon='folder' color='#d2b234' size='lg' />{' '}
            <span style={{ marginInlineStart: '6px' }}>{category}</span>
          </div>
        </div>
        <div className={`${styles['news-content']} d-flex flex-column`}>
          <h4 className={`${styles['news-title']}`}>{title}</h4>
          <p className={styles['news-description']}>{description}</p>
          <div className={styles.link}>
            <span>{t('readMore')}</span>
            <FontAwesomeIcon icon={isAr ? 'arrow-left' : 'arrow-right'} />
          </div>
        </div>
      </div>
    </Link>
  )
}

export default memo(NewsCard)
